import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { publicApi } from "@/lib/api";
import { Reveal } from "@/components/motion/Reveal";

export default function Normas() {
  const [items, setItems] = useState([]);
  useEffect(() => { publicApi.normas().then(setItems).catch(() => setItems([])); }, []);

  return (
    <section id="normas" className="relative py-24 md:py-36 border-t border-[#1A1A1A]/10 bg-[#EFEBE2]" data-testid="normas-section">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <div className="grid grid-cols-12 gap-6 items-end mb-14">
          <Reveal className="col-span-12 md:col-span-8">
            <div className="eyebrow mb-6">— 04 · Normas</div>
            <h2 className="display-2">Normas y certificaciones <em className="italic text-[#1B3B2B]">que atendemos</em>.</h2>
          </Reveal>
          <Reveal delay={0.15} className="col-span-12 md:col-span-4">
            <p className="text-sm text-[#4A4A4A] leading-relaxed">
              Sistemas de gestión, sostenibilidad y seguridad de la información. Cada certificación cuenta con acompañamiento integral desde el diagnóstico hasta el mantenimiento.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-[1px] bg-[#1A1A1A]/12 border border-[#1A1A1A]/12">
          {items.map((n, i) => (
            <motion.div
              key={n.id}
              initial={false}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ delay: i * 0.06, duration: 0.7, ease: [0.76, 0, 0.24, 1] }}
              className="bg-[#F9F6F0]"
            >
              <Link
                to={`/normas/${n.slug === "isoiec-27001" ? "iso-27001" : n.slug}`}
                className="group relative flex flex-col p-8 md:p-10 h-full hover:bg-[#1B3B2B] transition-colors duration-500"
                data-testid={`norma-card-${i}`}
              >
                <div className="flex justify-between items-start">
                  <div className="chapter-num text-[2rem] group-hover:text-[#F9F6F0] transition-colors">{String(i + 1).padStart(2, "0")}</div>
                  <ArrowUpRight className="w-5 h-5 text-[#1A1A1A] group-hover:text-[#F9F6F0] transition-colors" />
                </div>
                <div className="mt-6 font-serif text-[2rem] leading-tight text-[#1A1A1A] group-hover:text-[#F9F6F0] transition-colors">{n.codigo}</div>
                <div className="text-sm mt-1 text-[#4A4A4A] group-hover:text-[#F9F6F0]/70 transition-colors">{n.titulo}</div>
                <p className="mt-6 text-sm text-[#1A1A1A]/80 group-hover:text-[#F9F6F0]/85 transition-colors leading-relaxed">{n.resumen}</p>
                <div className="mt-auto pt-8 text-[11px] tracking-[0.22em] uppercase text-[#1A1A1A] group-hover:text-[#F9F6F0] transition-colors">
                  Explorar norma
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
